<template>
  <div>
    <div class="quotes-top">
      <div class="container">
        <el-tabs v-model="activeName" class="quotes-el-tab" :class="curClass" @tab-click="handleClick">
          <el-tab-pane name="four" v-if="isFreight || isWCA">
            <span slot="label" class="label"><i class="fa">&#xe676;</i>Air Freight</span><!--同行-->
            <div class="content">
              <check-forworder />
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane v-if="!isWCA && !isFreight" name="one"> -->
          <el-tab-pane name="one">
            <span slot="label" class="label"><i class="fa">&#xe62f;</i>EXPRESS</span>
            <div class="content">
              <check-expList :key="item" />
            </div>
          </el-tab-pane>
          <el-tab-pane name="two" v-if="!isFreight"><!--直客-->
            <span slot="label" class="label"><i class="fa">&#xe676;</i>Air Freight</span>
            <div class="content">
              <check-airList />
            </div>
          </el-tab-pane>
          
          <el-tab-pane name="three">
            <div slot="label" style="margin: 0 6px">
              <span class="label"
                ><i class="fa" style="margin-top: -3px; font-size: 14px">&#xe60d;</i
                >PICK-UP</span
              >
            </div>
            <div class="content">
              <pickup-service />
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- <span :class="isWCA ? 'wcaMoreTxt' : 'moreTxt'">MORE SERVICE COMING SOON...</span> -->
      </div>
    </div>
  </div>
</template>
<script>
import checkExpList from "@/components/userCenter/exp/checkExpList.vue";
import checkAirList from "@/components/userCenter/air/checkAirList.vue";
import checkForworder from "@/components/userCenter/air/checkForworder.vue";
import pickupService from "@/components/userCenter/pickup/pickupService.vue";
import { getCustomer } from "@/utils/getCustomer";
import {getCookie,delCookie} from '../../../ask/cookiejs'

export default {
  components: { pickupService, checkExpList, checkAirList,checkForworder },
  data() {
    return {
      activeName: "one",
      isWCA: false,
      isFreight:false,//同行显示
      item:'',//刷新组件
    };
  },
  created(){
     

  },

  computed: {
    curClass() {

      // if (this.isWCA) {
      //   if (this.activeName === "three") {
      //     return "isWcaPick";
      //   }
      // } else {
      //   return this.activeName;
      // }
      return this.activeName;
    },
    
  },
  mounted() {
      let  U_info = JSON.parse(getCookie('saveCustomerOwnerType'))
     // console.log("====.....",U_info);
     // debugger
      if(U_info){
          if(U_info.CustomerOwnerType == 0 || U_info.CustomerOwnerType == 1){//0直客 1国内同行
              this.isFreight=false;
              this.activeName ='two'
              // this.isFreight=true;
              // this.activeName ='four'
          }else{//海外同行
              this.isFreight=true;
              this.activeName ='four'
          }

          if(U_info.IsWCA){
            this.isFreight=true;
              this.isWCA=true
                this.activeName ='four'
          }
      }
    // getCustomer()
    //   .then((Customer) => {
    //     this.isWCA = Customer.IsWCA;
    //     if (this.isWCA) {
    //       this.activeName = "two";
    //     }
    //   })
    //   .catch((error) => {});
  },
  methods:{
    handleClick(tab, event){
      if(tab.name == "one"){
          this.item= new Date().getTime()
      }
    }
  }
};
</script>
<style>
.quotes-el-tab .el-tabs__header {
  height: 50px;
  background: white;
}
.quotes-el-tab .el-tabs__item {
  line-height: 50px;
  height: 50px;
  padding: 0 40px;
  font-size: 13px;
  font-weight: bold;
}
.quotes-el-tab .el-tabs__item .fa {
  font-weight: 300;
  margin-top: -3px;
  font-size: 13px;
  margin-right: 7px;
}
.quotes-el-tab .el-tabs__nav-wrap {
  padding-left: 40px;
}
/* 设置边距   */
.quotes-el-tab .el-tabs__active-bar {
  width: 80px !important;
}
.two .el-tabs__active-bar {
  transform: translateX(158px) !important;
}
.three .el-tabs__active-bar {
  transform: translateX(333px) !important;
}
.isWcaPick .el-tabs__active-bar {
  transform: translateX(176px) !important;
}
</style>
<style scoped>
.quotes-top {
  border-top: 1px solid #e1e1e1;
}
.quotes-top-tabs {
  background: white;
}
.quotes-top-tabs .label {
  font-size: 14px;
}

.content {
  padding: 0 40px;
  min-height: 400px;
}
.quotes-top {
  position: relative;
}
.moreTxt {
  position: absolute;
  top: 15px;
  left: 550px;
}
.wcaMoreTxt {
  position: absolute;
  top: 15px;
  left: 430px;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/quotes/index.vue